<template>
  <div>
    <!-- 编辑器 -->
    <quill-editor
      v-model="content"
      :ref="'quillEditor' + toolbarIndex"
      :options="editorOption"
      @focus="onEditorFocus($event)"
      @blur="onEditorBlur($event)"
      @change="onEditorChange($event)"
    >
      <div :id="'toolbar-' + toolbarIndex" slot="toolbar">
        <button class="ql-bold" title="加粗">Bold</button>
        <button class="ql-italic" title="斜体">I</button>
        <button class="ql-underline" title="下划线">U</button>
        <button class="ql-strike" title="删除线">S</button>
        <button class="ql-blockquote" title="引用"></button>
        <button class="ql-code-block" title="代码块"></button>
        <button class="ql-list" value="ordered" title="有序列表"></button>
        <button class="ql-list" value="bullet" title="无序列表"></button>
        <button class="ql-script" value="sub" title="下标"></button>
        <button class="ql-script" value="super" title="上标"></button>
        <button class="ql-indent" value="-1" title="向左缩进"></button>
        <button class="ql-indent" value="+1" title="向右缩进"></button>
        <select class="ql-header" title="段落格式">
          <option selected>正文</option>
          <option value="1">标题 1</option>
          <option value="2">标题 2</option>
          <option value="3">标题 3</option>
          <option value="4">标题 4</option>
          <option value="5">标题 5</option>
          <option value="6">标题 6</option>
        </select>
        <select class="ql-size" title="字体大小">
          <option value="small">10px</option>
          <option selected>14px</option>
          <option value="large">18px</option>
          <option value="huge">32px</option>
        </select>
        <select class="ql-color" value="color" title="字体颜色"></select>
        <select
          class="ql-background"
          value="color"
          title="字体背景颜色"
        ></select>
        <select class="ql-font" title="字体类型">
          <option value="SimSun">宋体</option>
          <option value="SimHei">黑体</option>
          <option value="Microsoft-YaHei" selected>微软雅黑</option>
          <option value="KaiTi">楷体</option>
          <option value="FangSong">仿宋</option>
          <option value="Arial">Arial</option>
          <option value="Times-New-Roman">Times New Roman</option>
          <option value="sans-serif">sans-serif</option>
        </select>
        <select class="ql-align" title="字体大小">
          <option selected></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
        <button class="ql-clean" title="清除格式"></button>
        <button class="ql-link" title="链接"></button>
        <button class="ql-image" title="上传图片"></button>
        <button class="ql-video" title="上传视频"></button>
      </div>
    </quill-editor>

    <!-- 文件上传 -->
    <el-upload
      :id="'upload-image-' + toolbarIndex"
      :key="'image-' + toolbarIndex"
      class="image-uploader"
      :action="fileConfig.path"
      :name="fileConfig.locationName"
      :show-file-list="false"
      v-show="false"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :before-upload="beforeUpload"
      :accept="'image/gif, image/jpeg, image/jpg, image/png'"
    ></el-upload>
    <el-upload
      :id="'upload-video-' + toolbarIndex"
      :key="'video-' + toolbarIndex"
      class="video-uploader"
      :action="fileConfig.path"
      :name="fileConfig.locationName"
      :show-file-list="false"
      v-show="false"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :before-upload="
        (res, file) => {
          return beforeUpload(res, file, 'adasda');
        }
      "
      :accept="'video/*'"
    ></el-upload>

    <el-dialog
      class="loading-percent-modal"
      :visible.sync="loadingVisible"
      width="400px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="loading-bar">
        <span class="loading-bar-text"
          >{{
            this.fileConfig.resourceType == "image"
              ? "图片上传中"
              : "视频上传中"
          }}：</span
        >
        <div class="out-bar">
          <div class="loading-percent" :style="{ width: loadingPercent + '%' }">
            {{ loadingPercent }}%
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; // 调用富文本编辑器
import * as Quill from "quill"; // 富文本基于quill
import * as qiniu from "qiniu-js";
//quill图片可拖拽改变大小
// import imageResize from 'quill-image-resize-module';
// Quill.register('modules/imageResize', imageResize);
//quill图片拖拽
// import { ImageDrop } from 'quill-image-drop-module';
// Quill.register('modules/imageDrop', ImageDrop);

import { Video } from "@/util/quill-video";
Quill.register({ "formats/video": Video }, true);

var fonts = [
  "SimSun",
  "SimHei",
  "Microsoft-YaHei",
  "KaiTi",
  "FangSong",
  "Arial",
  "Times-New-Roman",
  "sans-serif"
];
var Font = Quill.import("formats/font");
Font.whitelist = fonts; //将字体加入到白名单
Quill.register(Font, true);

import validate from "@/util/validate";
import { qiniuToken } from "@/api/index";

export default {
  props: ["initContent", "toolbarIndex"],
  data() {
    var _this = this;
    return {
      editor: null, // 富文本编辑器对象
      // content: `<p></p><p><br></p><ol></ol>`, // 富文本编辑器默认内容
      content: ``, // 富文本编辑器默认内容
      fileConfig: {
        path: "https://upload-z2.qiniup.com",
        resourceType: "image",
        locationName: "image"
      },
      editorOption: {
        //  富文本编辑器配置
        modules: {
          toolbar: {
            container: "#toolbar-" + _this._props.toolbarIndex
          }
          // imageResize: {},
          // imageDrop: {}
        },
        theme: "snow",
        placeholder: "请输入正文"
      },
      qiniu_token: "",
      qiniu_base_url: "https://yhgtk.fruitbloom.com.cn/",
      loadingVisible: false,
      loadingPercent: 0,
      quill_index: 0
    };
  },
  components: {
    quillEditor
  },
  mounted() {
    this.editor = this.$refs["quillEditor" + this._props.toolbarIndex].quill;

    this.quill_index = this._props.toolbarIndex;

    if (!validate.checkNull(this._props.initContent)) {
      this.content = this._props.initContent;
    }

    this.getQiniuToken();

    let that = this;

    // 工具栏中的图片图标被单击的时候调用这个方法
    let imgHandler = function(state) {
      if (state) {
        that.fileConfig.resourceType = "image";
        that.fileConfig.locationName = "image";
        document.querySelectorAll(".image-uploader input")[that._props.toolbarIndex - 1].click();
      }
    };
    // 工具栏中的视频图标被单击的时候调用这个方法
    let videoHandler = function(state) {
      if (state) {
        that.fileConfig.resourceType = "video";
        that.fileConfig.locationName = "video";
        document.querySelectorAll(".video-uploader input")[that._props.toolbarIndex - 1].click();
      }
    };

    // 当工具栏中的图片图标被单击的时候
    this.$refs["quillEditor" + this.quill_index].quill
      .getModule("toolbar")
      .addHandler("image", imgHandler);
    // 当工具栏中的视频图标被单击的时候
    this.$refs["quillEditor" + this.quill_index].quill
      .getModule("toolbar")
      .addHandler("video", videoHandler);
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  watch: {
    initContent(newVal, oldVal) {
      if (!validate.checkNull(newVal)) {
        this.content = newVal;
      }
    },
    toolbarIndex(newVal, oldVal) {}
  },
  methods: {
    // 准备富文本编辑器
    onEditorReady(editor) {
      console.log("Ready", editor);
    },
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {
      console.log("Blur", editor);
    },
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {
      console.log("Focus", editor);
    },
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      // console.log('Change', editor)
    },
    beforeUpload(file) {
      if (this.uploadSizeOver(this.fileConfig.resourceType, file)) {
        return;
      }
      let that = this;
      var observable = qiniu.upload(
        file,
        file.name + Date.now(),
        that.qiniu_token
      );
      this.loadingVisible = true;
      observable.subscribe({
        next(res) {
          console.log("upload...", res); //res.total.percent;
          that.loadingPercent = parseInt(res.total.percent);
        },
        error(error) {
          that.$message.error("上传失败");
          that.loadingVisible = false;
          that.loadingPercent = 0;
          console.log("error", error);
        },
        complete: complete => {
          that.loadingVisible = false;
          that.loadingPercent = 0;
          console.log("complete", complete);
          let quill =
            that.$refs["quillEditor" + that._props.toolbarIndex].quill;
          let length = quill.getSelection().index;
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(
            length,
            that.fileConfig.resourceType,
            that.qiniu_base_url + complete.key
          );
          // 调整光标到最后
          quill.setSelection(length + 1);
        }
      });
    },
    // 上传图片成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    // 上传图片失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
    getQiniuToken() {
      qiniuToken()
        .then(response => {
          this.qiniu_token = response.data;
        })
        .catch(error => {
          this.qiniu_token = "";
        });
    },
    uploadSizeOver(type, file) {
      switch (type) {
        case "image":
          let imgTypes = ["image/jpg", "image/jpeg", "image/gif", "image/png"];
          if (imgTypes.indexOf(file.type) === -1) {
            this.$message.warning("请上传正确格式图片，支持jpg/jpeg/gif/png");
            return true;
          }
          if (file.size > 100 * 1024 * 1024) {
            this.$message.warning("图片文件大小不大于100K");
            return true;
          }
          break;
        case "video":
          if (file.type.indexOf("video") === -1) {
            this.$message.warning("请上传正确视频格式");
            return true;
          }
          if (file.size > 256 * 1024 * 1024) {
            this.$message.warning("视频文件大小不大于256M");
            return true;
          }
          break;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-bar {
  .loading-bar-text {
    font-size: 16px;
    font-weight: bold;
  }
  .out-bar {
    margin-top: 15px;
    border: 1px solid #666;
    .loading-percent {
      background: #8aea7e;
      text-align: right;
    }
  }
}
</style>

<style lang="scss">
.loading-percent-modal .el-dialog__header {
  display: none;
}
.ql-snow .ql-picker {
  line-height: 24px;
}
</style>
